<template>
   <div class="kye-multiple-dept-dialog-body-panel">
      <div class="kye-multiple-dept-dialog-body-panel-title">
        <span class="kye-multiple-dept-dialog-body-panel-title-text">已选组织（<span>{{checkedNodes.length}}</span>）</span>
        <kye-button style="float:right;margin-top: -6px;" type="text" icon="layout layout-delete" @click="deleteAllChecked">清空</kye-button>
      </div>
      <div class="kye-multiple-dept-dialog-body-panel-content">
        <span
          v-for="item in checkedNodes"
          :key="item.id"
          class="kye-multiple-dept-dialog-body-panel-content-item"
        >
          <span v-if="deptMap[item] && deptMap[item].name">{{deptMap[item] && deptMap[item].name}}
            <i
              v-if="deptMap[item] && deptMap[item].name"
              class="el-icon-close kye-multiple-dept-dialog-body-panel-content-item-icon"
              @click="handleDeleteCheckedNode(item)"
            ></i>
          </span>

        </span>
      </div>
    </div>
</template>

<script>
export default {
  props: {
    deptMap: {
      type: Object,
      default: () => ({})
    },
    checkedNodes: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {}
  },
  methods: {
    deleteAllChecked () {
      this.$emit('deleteAllChecked')
    },
    handleDeleteCheckedNode (item) {
      this.$emit('handleDeleteCheckedNode', item)
    }
  }
}
</script>

<style lang="less" scoped>
.kye-multiple-dept-dialog-body-panel {
  &-title {
    padding: 16px;
    border-bottom: 1px solid #e9e8ed;
    margin-bottom: 16px;
    &-text {
      font-size: 14px;
      font-weight: bold;
      text-align: left;
      color: #333333;
      line-height: 14px;
      >span {
        color: var(--g-color-primary);
      }
    }
  }
  margin-left: 12px;
  width: 550px;
  border: 1px solid #e9e8ed;
  border-radius: 4px;
  &-content {
    max-height:calc(60vh - 92px);
    overflow-y:auto;
    display: flex;
    flex-wrap: wrap;
    padding: 16px;
    padding-top: 0;
    &-item {
      background: #F4F4F6;
      margin-right: 12px;
      margin-bottom: 12px;
      border-radius: 2px;
      padding: 9px 8px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      font-weight: 400;
      text-align: left;
      color: #333333;
      line-height: 14px;
      &-icon {
        margin-left: 8px;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-dept-multiple/components/checked-dept-panel.vue